import moment from 'moment';
import styled from 'styled-components';
import { defaultImage } from '../../../methods/utils/general-utils';

interface IGameActionActivitiesItem {
	activitiesAction: any;
}

const Style = styled.div`
	padding: 20px;
	background-color: #f8f8f8;
	margin-bottom: 10px;

	& .title {
		font-size: 18px;
		font-weight: 600;
		text-transform: capitalize;
	}

	& .details {
		margin-top: 7px;
		border-top: 1px dashed #ddd;
		padding-top: 10px;

		& .label {
			font-style: italic;
			font-size: 14px;
			color: #aaa;
		}

		& .currency {
			display: flex;
			& img {
				width: 20px;
				height: 20px;
				border-radius: 50%;
				margin-right: 10px;
			}
		}

		& > * {
			display: inline-block;
			margin-right: 20px;
			margin-top: 10px;
		}
	}
`;

const GameActionActivitiesItem = ({
	activitiesAction,
}: IGameActionActivitiesItem) => (
	<Style>
		<div className="details">
			<div>
				<p className="label">FullName</p>

				<p style={{ textTransform: 'capitalize' }}>
					{activitiesAction.userId.fullName}
				</p>
			</div>
			<div>
				<p className="label">User Name</p>

				<p style={{ textTransform: 'capitalize' }}>
					{activitiesAction.userId.username}
				</p>
			</div>
			<div>
				<p className="label">Game Title</p>

				<p style={{ textTransform: 'capitalize' }}>
					{activitiesAction.gameId.title}
				</p>
			</div>
			<div>
				<p className="label">Game Status</p>

				<p style={{ textTransform: 'capitalize' }}>
					{activitiesAction.gameId.status}
				</p>
			</div>
			<div>
				<p className="label">Game End Date </p>
				<p style={{ textTransform: 'capitalize' }}>
					{' '}
					{activitiesAction.gameId.endDate
						? moment(activitiesAction.gameId.endDate).format('MMM DD, YY')
						: '--'}
				</p>
			</div>
			<div>
				<p className="label">Amount</p>

				<p style={{ textTransform: 'capitalize' }}>
					{activitiesAction.savingsAmount}
				</p>
			</div>
			<div>
				<p className="label">Game Action</p>

				<p style={{ textTransform: 'capitalize' }}>
					{activitiesAction.gameActionPointId?.gameKey}
				</p>
			</div>
			<div>
				<p className="label">Currency</p>
				<p style={{ display: 'flex', alignItems: 'center' }}>
					<img
						style={{ marginRight: '10px' }}
						alt=""
						src={activitiesAction.currencyId?.iconUrl || defaultImage}
						width={20}
					/>
					<p style={{ textTransform: 'capitalize' }}>
						{activitiesAction.currencyId?.symbol}
					</p>
				</p>
			</div>
			<div>
				<p className="label">Created Date</p>
				<p style={{ textTransform: 'capitalize' }}>
					{' '}
					{activitiesAction.createdAt
						? moment(activitiesAction.createdAt).format('MMM DD, YY')
						: '--'}
				</p>
			</div>
		</div>
	</Style>
);

export default GameActionActivitiesItem;
